export default __webpack_public_path__ + "static/media/Morph Phlegmatic Fiend.ad3a4c0a.jpg";